import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const CaruselItem = (props) => {
  const [width, setWidth] = useState(window.innerWidth);
  

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const image = ()=>{
    if (width >= '1200'){
      return process.env.REACT_APP_UPLOAD_URL + props.data.ImageLarge.data.attributes.url
    } else if (width >= '600' && width < '1200'){
      return process.env.REACT_APP_UPLOAD_URL + props.data.ImageMedium.data.attributes.url
    } else if(width < '600'){
      return process.env.REACT_APP_UPLOAD_URL + props.data.ImageSmall.data.attributes.url
    }
  }

  return (
    <div className="slider_wrapper_content">
      <div className="slider_wrapper_content--data">
        <div className="slider_wrapper_content--data-frame">
          <h1>{props.data.Title}</h1>
          <span>{props.data.SubTitle}</span>
          <div className="slider_wrapper_content--data-frame-links">
            {props.data.Link && (
              <Link
                to={props.data.Link.URL}
                className="slider_wrapper_content--data-frame-links-primary"
              >
                {props.data.Link.linkText}
              </Link>
            )}
            <Link
              to="/Contacto"
              className="slider_wrapper_content--data-frame-links-secondary"
            >
              Me Interesa
            </Link>
          </div>
        </div>
      </div>
      <div className="slider_wrapper_content--img">
      <img
            src={image()}
            alt=""
          />
      </div>
    </div>
  );
};

export default CaruselItem;
